import React from 'react';
import { FaFileAlt, FaSearch } from 'react-icons/fa';
import styles from '../OrderList.module.css';

function OrderFilterSortSearch({
    setOrderStatus,
    setReceiveReturn,
    setLoading,
    setSearchNum,
    searchN,
    orderStatus,
    aiUnreached,
    showAiUnreached,
    ReceiveReturn,
    triggerSearch,
    setRefreshSe,
}) {
    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!searchN) return;
        setLoading(true);
        triggerSearch();
    };

    // Update search state
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchNum(value);
        if (value === '') {
            setRefreshSe((prev) => prev + 1);
        }
    };

    // Navigate to report
    const navigateToReport = () => {
        window.location.href = '/advance-report';
    };

    return (
        <div className={styles['shopify-filter-main']}>
            <div className={styles['shopify-status-filters']}>
                <div className={styles['filter-chips']}>
                    <button
                        className={`${styles['filter-chip']} ${
                            !orderStatus ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus();
                            setReceiveReturn(false);
                        }}
                    >
                        All Orders
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 1 && !aiUnreached ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(1);
                            setReceiveReturn(false);
                        }}
                    >
                        New
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 2 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(2);
                            setReceiveReturn(false);
                        }}
                    >
                        Call Done
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 7 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(7);
                            setReceiveReturn(false);
                        }}
                    >
                        Call Not Received
                    </button>
                    {showAiUnreached && (
                        <button
                            className={`${styles['filter-chip']} ${aiUnreached ? styles['active'] : ''}`}
                            onClick={() => {
                                showAiUnreached();
                                setReceiveReturn(false);
                            }}
                            title="New orders the AI called but never reached — call them yourself"
                        >
                            AI couldn't reach
                        </button>
                    )}
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 8 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(8);
                            setReceiveReturn(false);
                        }}
                    >
                        Ask Advance
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 9 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(9);
                            setReceiveReturn(false);
                        }}
                    >
                        Ship Later
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 3 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(3);
                            setReceiveReturn(false);
                        }}
                    >
                        Courier Done
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 10 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(10);
                            setReceiveReturn(false);
                        }}
                    >
                        Waiting
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 4 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(4);
                            setReceiveReturn(false);
                        }}
                    >
                        Print
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 5 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(5);
                            setReceiveReturn(false);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 6 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(6);
                            setReceiveReturn(false);
                        }}
                    >
                        Return
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 11 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(11);
                            setReceiveReturn(false);
                        }}
                    >
                        Overseas
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            ReceiveReturn === true ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setReceiveReturn(true);
                            setOrderStatus(100);
                        }}
                    >
                        Pending Return
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 12 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(12);
                            setReceiveReturn(false);
                        }}
                    >
                        Delivery Issue
                    </button>
                    <button
                        className={`${styles['filter-chip']} ${
                            orderStatus === 13 ? styles['active'] : ''
                        }`}
                        onClick={() => {
                            setOrderStatus(13);
                            setReceiveReturn(false);
                        }}
                    >
                        Payment Received
                    </button>
                </div>
            </div>

            <div className={styles['shopify-search-section']}>
                <form onSubmit={handleSubmit} className={styles['search-form']}>
                    <button
                        className={styles['shopify-report-btn']}
                        onClick={navigateToReport}
                        type="button"
                    >
                        <FaFileAlt />
                        Advance Report
                    </button>
                    <input
                        type="text"
                        name="searchInput"
                        placeholder="Search by mobile, invoice, or name"
                        className={styles['shopify-search-input']}
                        value={searchN}
                        onChange={handleInputChange}
                    />
                    <button
                        type="submit"
                        className={styles['shopify-search-submit']}
                    >
                        <FaSearch />
                        Search
                    </button>
                </form>
            </div>
        </div>
    );
}

export default OrderFilterSortSearch;
